import script from "./modal-content-right.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-content-right.vue?vue&type=script&setup=true&lang=js"

import "./modal-content-right.vue?vue&type=style&index=0&id=bbd015de&lang=less"

const __exports__ = script;

export default __exports__